<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite"
          >新增</el-button
        >
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="Status==2 || !canWrite"
          >保存</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          :disabled="!isSave||Status==2 || !canWrite"
          @click="handleDelete"
          >删除</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="reView"
          :disabled="!isSave||Status==2 || !canReview"
          >审核</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 4px"
          @click="cancelReView"
          :disabled="!isSave||Status!=2 || !canReview"
          >弃审</el-button
        >
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave"
          >打印</el-button
        >
      </div>
      <el-form
        :model="data"
        ref="form"
        :inline="true"
        :line-form="true"
        label-width="100px"
        status-icon
      >
        <el-row style="margin-top: 18px">
          <el-form-item label="单据编码" label-width="100px" prop="DocNo">
            <span
              style="display: inline-block; width: 180px"
              v-if="Mode == 0"
              class="detail-span"
              >{{ data.DocNo }}</span
            >
            <el-input
              style="width: 180px"
              v-else
              v-model="data.DocNo"
              placeholder="请输入单据编码"
            ></el-input>
          </el-form-item>
          <el-form-item label="单据日期" label-width="100px" prop="DocDate">
            <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span>
            <el-date-picker
              v-else
              v-model="data.DocDate"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              style="width: 180px"
              @change="(v) => getPreviewNo(v)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="经手人:" prop="ClerkId">
            <span class="not-edit" v-if="Status === 2">{{ data.ClerkName }}</span>
            <select-input
              v-else
              placeholder="请选择经办人"
              :label="data.ClerkName"
              v-model="data.ClerkId"
              @click="openEmp"
              style="width: 180px"
            />
          </el-form-item>
          <el-form-item label="业务类型" required>
            <span class="not-edit" v-if="Status === 2">{{ BusinessType }}</span>
            <el-select
              v-model="data.BusinessTypeId"
              style="width: 180px"
              v-else
              @change="changeBusinessType"
            >
              <el-option
                v-for="item in businessTypeList"
                :key="item.key"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>

      <div class="flex space-between align_items">
        <div class="el-form-item__label" style="margin-left: 8px">存取信息</div>
        <div>
          <el-button
            type="primary"
            style="margin-right: 8px"
            @click="add"
            v-if="Status !== 2"
            >添加</el-button
          >
        </div>
      </div>

      <el-table
        border
        class="table_bottom table-line tb-c-head tb-head-color"
        :data="tableData"
        stripe
      >
        <el-table-column
          label="转出账户"
          prop="OutAccountId"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }"> 
            <span class="not-edit" v-if="Status === 2">{{
              row.OutAccountName
            }}</span>
            <el-select
              v-model="row.OutAccountId"
              @change="changeOutAccountId(row)"
              v-else
            >
              <el-option
                v-for="item in accountList"
                :key="item.AccountId"
                :label="item.AccountName"
                :value="item.AccountId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="转出金额"
          prop="OutAmount"
          align="center"
          min-width="100"
          v-if="canPrice"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.OutAmount }}</span>
            <el-input
              type="number"
              v-model="row.OutAmount"
              @change="changeOutAmount($event, row)"
              v-else
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="转入账户"
          prop="InAccountId"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }"> 
            <span class="not-edit" v-if="Status === 2">{{
              row.InAccountName
            }}</span>
            <el-select
              v-model="row.InAccountId"
              @change="changeInAccountId(row)"
              v-else
            >
              <el-option
                v-for="item in accountList"
                :key="item.AccountId"
                :label="item.AccountName"
                :value="item.AccountId"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="转入金额"
          prop="InAmount"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.InAmount }}</span>
            <el-input
              type="number"
              v-else
              v-model="row.InAmount"
              @change="changeInAmount($event, row)"
            ></el-input>
          </template>
        </el-table-column> -->
        <el-table-column
          label="备注"
          prop="Remark"
          align="center"
          min-width="100"
        >
          <template slot-scope="{ row }">
            <span class="not-edit" v-if="Status === 2">{{ row.Remark }}</span>
            <el-input
              v-model="row.Remark"
              :disabled="Status == 2"
              v-else
              @change="changeRemark(row)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row, $index }">
            <el-button
              type="text"
              @click="del(row, $index)"
              :disabled="Status == 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="mtx10">
        <div class="flex">
          <div class="text el-form-item__label">备注</div>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="data.Remark"
            :disabled="Status == 2"
          ></el-input>
        </div>
      </div>

      <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">制单人</div>
            <div class="center el-form-item__label">{{ data.MakeEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewDate }}</div>
          </div>
        </div>
      </div>
    </div>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import empDialog from "@/components/personnel/result/record/listDialog";

export default {
  name: "editbankaccess",
  components: {
    empDialog,
  },
  data() {
    return {
      businessTypeApi: require("@/api/ba/businessType").default,
      code_api: require("@/api/sy/serialCode").default,
      accountApi: require("@/api/ba/account").default,
      api: require("@/api/rp/bankDoc").default,
      BusinessType: "",
      businessTypeList: [
        {
          key: "b1",
          label: "存款",
          value: 0,
        },
        {
          key: "b2",
          label: "转账",
          value: 1,
        },
        {
          key: "b3",
          label: "提现",
          value: 2,
        },
        {
          key: "b4",
          label: "其他",
          value: 3,
        },
      ],
      accountList: [],
      isSave: false,
      data: {
        DocId: 0,
        ClerkId: "",
        ClerkName: "",
        DocNo: "",
        DocDate: this.$commonJs.getToday(),
        BusinessTypeId: "",
        Remark: "",
        MakeEmpName: "",
        MakeClerkId: 0,
        AsReviewEmpName: "",
        ReviewEmpId: 0,
        ReviewDate: "",
      },
      date: [],
      tableData: [
        {
          T: 0,
          DocDtsId: 0,
          DocId: 0,
          OutAccountId: null,
          OutAmount: 0,
          InAccountId: null,
          // InAmount: 0,
          Remark: "",
          InClassId: 0,
          InHaveBank: true,
          OutClassId: 0,
          OutHaveBank: true,
        },
      ],
      delTableData: [],
      viewType: "create",
      Status: 0,
      Mode: 0,
    };
  },

  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/cashier/bankaccess");
    },
    canWrite() {
      return this.$permission.canWrite("/finance/cashier/bankaccess");
    },
    canReview() {
      return this.$permission.canReview("/finance/cashier/bankaccess");
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.viewType = this.$route.params.type;

    if (this.$route.params.type === "create") {
      this.getPreviewNo();
    } else if (this.$route.params.type === "edit") {
      this.editInit(this.$route.params.data);
    }
  },

  methods: {
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    init() {
      const user = this.$store.state.user;
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }


      this.accountApi.list({ Status: 1 }).then((res) => {
        if (res.Code === 0) {
          this.accountList = res.Data;
        }
      });
    },
    editInit(data) {
      this.viewType = "edit";
      this.isSave = true;
      let {
        DocId,
        ClerkId,
        ClerkName,
        DocNo,
        DocDate,
        BusinessTypeId,
        Remark,
        Status,
        MakeEmpName,
        MakeClerkId,
        AsReviewEmpName,
        ReviewEmpId,
        ReviewDate,
        Dts,
      } = data;
      this.Status = Status;
      this.data = {
        DocId,
        ClerkId,
        ClerkName,
        DocNo,
        DocDate,
        BusinessTypeId,
        Remark,
        MakeEmpName,
        MakeClerkId,
        AsReviewEmpName,
        ReviewEmpId,
        ReviewDate,
      };

      this.changeBusinessType(BusinessTypeId);

      Dts.forEach((item) => {
        item.T = null;
      });

      this.tableData = Dts;
    },
    getPreviewNo(dateTime = "") {
      this.code_api.previewNo("银行存取款单", dateTime).then((res) => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取银行存取款单编号失败");
        }
      });
    },
    changeOutAmount(val, row) {
      this.editT(row);
      val = parseFloat(val);
      row.OutAmount = parseFloat(val.toFixed(2));
    },
    // changeInAmount(val, row) {
    //   this.editT(row);
    //   val = parseFloat(val);
    //   row.InAmount = parseFloat(val.toFixed(2));
    // },
    changeInAccountId(row) {
      this.editT(row);
    },
    changeOutAccountId(row) {
      this.editT(row);
    },
    changeRemark(row) {
      this.editT(row);
    },
    changeBusinessType(val) {
      this.BusinessType = this.businessTypeList.filter((item) => {
        return item.value === val;
      })[0].label;
    },
    save(type = 0) {
      let DocDtss = this.tableData;
      //DocDtss 
      //OutAccountId
      for(let i=0;i<= DocDtss.length-1;i++){    
        if(DocDtss[i].OutAccountId==0 || DocDtss[i].OutAccountId==null )  return   this.$message({ type: "warning", message: "请选择转出账户" });
        if(DocDtss[i].InAccountId==0 || DocDtss[i].InAccountId==null )  return   this.$message({ type: "warning", message: "请选择转入账户" }); 
        }
        DocDtss = DocDtss.filter((item) => {
        return item.T != null;
      });
      if(this.data.BusinessTypeId ||this.data.BusinessTypeId===0){
       console.log(this.data.BusinessTypeId,'this.data.BusinessTypeId')
      }else{
        return this.$message({ type: "warning", message: "请选择业务类型" });
      }
  
      DocDtss = DocDtss.concat(this.delTableData);
      console.log(DocDtss,'DocDtss')
      let o = {
        DocDtss,
        ...this.data,
      };
    


      this.api.save(o).then((res) => {
        if (res.Code === 0) {
          this.isSave = true;

          if (this.viewType === "create") {
            this.data.DocId = res.Data;
          }
          if(type !== 1){
            this.$message.success(res.Msg);
          }

          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              if(type === 1){
                this.reView1()
              }else{
                this.editInit(res.Data);
              }
              
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    del(row, index) {
      this.$confirm("确认删除这条数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        if (row.T !== 0) {
          row.T = 2;
          this.delTableData.push(row);
        }
        this.tableData.splice(index, 1);
      });
    },
    add() {
      let o = {
        T: 0,
        DocDtsId: 0,
        DocId: 0,
        OutAccountId: 0,
        OutAmount: 0,
        InAccountId: 0,
        InAmount: 0,
        Remark: "",
        InClassId: 0,
        InHaveBank: true,
        OutClassId: 0,
        OutHaveBank: true,
      };

      this.tableData.push(o);
    },
    handleDelete() {
      let id = this.data.DocId;
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((res) => {
        this.api.delete({ Id: id }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.newAdd();
            // this.$emit('deleted')
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: "warning", message: "请先进行保存再操作" });
        return;
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
        this.$route.params.type = "create";
        this.viewType = "create";
        this.init();
        this.getPreviewNo();
        this.isSave = false;
      }
    },
    reView1() {
      let id = this.data.DocId;
      this.api.examine(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
    reView() {
      this.save(1)
    },
    cancelReView() {
      let id = this.data.DocId;
      this.api.cancel(id).then((res) => {
        if (res.Code === 0) {
          this.$message({ type: "success", message: res.Msg });
          this.api.info(this.data.DocId).then((res) => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data;
              this.editInit(res.Data);
            }
          });
        } else {
          this.$message({ type: "warning", message: res.Msg });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.mtx18 {
  margin-top: 18px;
}

.mrx24 {
  margin-right: 100px;
  color: #b3b3b3;
}

.flex {
  display: flex;
  .text {
    width: 60px;
  }
}
.space-between {
  justify-content: space-between;
}
.align_items {
  align-items: center;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}
.span {
  display: inline-block;
  width: 180px;
}
</style>
